import {Filter} from "@/features/catalog-filters";

export const isFilterVisible = (filter: Filter) => {
    if (!filter.visible) {
        return false;
    }

    if (filter.type === "range") {
        return !(filter.options.value_min === null && filter.options.value_max === null);
    }

    return filter.options.length > 0;
};
